import React from 'react';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import AssigneeField from '@atlassian/jira-issue-create-commons/src/ui/assignee-field/index.tsx';
import type { UserValue } from '@atlassian/jira-issue-field-assignee/src/common/types.tsx';
import { ASSIGNEE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { AssigneeFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { assigneeFieldWriter } from '../writers/index.tsx';

const AssigneeFieldTypeComponent = (props: ProvidedFieldProps) => <AssigneeField {...props} />;

export const AssigneeFieldTypeConfig: FieldTypeConfig<UserValue> = {
	icon: PersonAvatarIcon,
	type: ASSIGNEE_TYPE,
	Component: AssigneeFieldTypeComponent,
	placeholder: <AssigneeFieldPlaceholder />,
	writer: assigneeFieldWriter,
};
